import {inject, Injectable}                                                                                        from '@angular/core';
import {BodyConfIntf, BodyRecordLogIntf, BodyRecordSumIntf, BodySymptomType, FirebasePaths, GlobalRecordGroupDict} from '@djsharkk/logr-types';
import {BehaviorSubject}                                                                                           from 'rxjs';
import {AuthUnlockService}                                                                                         from '../../../logr-auth/utils/auth-unlock.service';
import {DataFirebaseBase}                                                                                          from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataBodyService extends DataFirebaseBase<BodyRecordLogIntf, BodyRecordSumIntf> {
	svcAuthUnlock = inject(AuthUnlockService)

	protected paths: GlobalRecordGroupDict<FirebasePaths, FirebasePaths | undefined> = {
		log: 'body_records_log',
		sum: 'body_records_sum'
	};

	bodyConf = new BehaviorSubject<BodyConfIntf[]>([]);

	constructor() {
		super();
		this.svcFirebaseTools.recFetch<BodyConfIntf>('body_conf').subscribe(conf => this.bodyConf.next(conf))

		this.records.log.subscribe(records => {
			records
				.filter(record => record.note?.length)
				.forEach(record => {
					if (record.note) {
						this.svcAuthUnlock.decrypt(record.note).then(note => record.note = note)
					}

					const body = Promise.all(
						record.body.map(async (mind) => await this.svcAuthUnlock.decrypt(mind))
					);

					body.then(b => record.body = b as BodySymptomType[])
				})

			console.log(records)
		})
	}


	createRecord(record: BodyRecordLogIntf) {
		this.svcFirebaseTools.recCreate<BodyRecordLogIntf>(this.paths.log, record);
	}
}
